"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStats = void 0;
/* eslint-disable max-classes-per-file */
const currency_1 = require("@helium/currency");
const Transactions_1 = __importDefault(require("../resources/Transactions"));
const PendingTransactions_1 = __importDefault(require("../resources/PendingTransactions"));
const Hotspots_1 = __importDefault(require("../resources/Hotspots"));
const Challenges_1 = __importDefault(require("../resources/Challenges"));
const DataModel_1 = __importDefault(require("./DataModel"));
const Rewards_1 = __importDefault(require("../resources/Rewards"));
function toBalance(value, type) {
    if (value === undefined)
        return undefined;
    return new currency_1.Balance(value, type);
}
class AccountStats {
    constructor(data) {
        this.lastWeek = data.last_week.map((s) => ({
            timestamp: s.timestamp,
            balance: toBalance(s.balance, currency_1.CurrencyType.default),
        }));
        this.lastMonth = data.last_month.map((s) => ({
            timestamp: s.timestamp,
            balance: toBalance(s.balance, currency_1.CurrencyType.default),
        }));
        this.lastDay = data.last_day.map((s) => ({
            timestamp: s.timestamp,
            balance: toBalance(s.balance, currency_1.CurrencyType.default),
        }));
    }
}
exports.AccountStats = AccountStats;
class Account extends DataModel_1.default {
    constructor(client, account) {
        super();
        this.client = client;
        this.speculativeNonce = account.speculative_nonce;
        this.secNonce = account.sec_nonce;
        this.secBalance = toBalance(account.sec_balance, currency_1.CurrencyType.security);
        this.nonce = account.nonce;
        this.dcNonce = account.dc_nonce;
        this.dcBalance = toBalance(account.dc_balance, currency_1.CurrencyType.dataCredit);
        this.block = account.block;
        this.balance = toBalance(account.balance, currency_1.CurrencyType.default);
        this.address = account.address;
    }
    get activity() {
        return new Transactions_1.default(this.client, this);
    }
    get hotspots() {
        return new Hotspots_1.default(this.client, this);
    }
    get challenges() {
        return new Challenges_1.default(this.client, this);
    }
    get pendingTransactions() {
        return new PendingTransactions_1.default(this.client, this);
    }
    get rewards() {
        return new Rewards_1.default(this.client, this);
    }
    get data() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = this, { client } = _a, rest = __rest(_a, ["client"]);
        return Object.assign({}, rest);
    }
}
exports.default = Account;
//# sourceMappingURL=Account.js.map